import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

export default {
  getHeaders () {
    const user = JSON.parse(sessionStorage.getItem('user'))

    return {
      id: user ? user.login : '',
      'content-type': 'text/plain'
    }
  },

  async createRoleAdministrateur (login) {
    return axios.post('/droits/createAdmin', login, { headers: this.getHeaders(), withCredentials: true })
  },

  async createRoleAdministrateurBo (login) {
    return axios.post('/droits/createAdminBO', login, { headers: this.getHeaders(), withCredentials: true })
  },

  async createRoleGestionnaire (login) {
    return axios.post('/droits/createGestionnaire', login, { headers: this.getHeaders(), withCredentials: true })
  },

  async createRolePorteur (login) {
    return axios.post('/droits/createPorteur', login, { headers: this.getHeaders(), withCredentials: true })
  },

  async createRoleDemoGestionnaire (login) {
    return axios.post('/droits/createDemoGestionnaire', login, { headers: this.getHeaders(), withCredentials: true })
  },

  async createRoleDemoPorteur (login) {
    return axios.post('/droits/createDemoPorteur', login, { headers: this.getHeaders(), withCredentials: true })
  },

  async createXarmRoleLogsAdmin (login) {
    return axios.post('/droits/createLogsAdmin', login, { headers: this.getHeaders(), withCredentials: true })
  },

  async addPermAddtPorteurData (login) {
    return axios.post('/droits/createAddtData', login, { headers: this.getHeaders(), withCredentials: true })
  },

  async addPermissDDDSecure (login) {
    return axios.post('/droits/createDDDSecure', login, { headers: this.getHeaders(), withCredentials: true })
  },

  async addPermissEmailMaj (login) {
    return axios.post('/droits/createEmailMaj', login, { headers: this.getHeaders(), withCredentials: true })
  },

  async addPermAddtPorteurDataAdmin (login) {
    return axios.post('/droits/createAddtPorteurAdmin', login, { headers: this.getHeaders(), withCredentials: true })
  },

  async getPermissionsForRole (roleName) {
    return axios.post('/droits/getPermissionsForRole', roleName, { headers: this.getHeaders(), withCredentials: true })
  },

  async addOrRemovePermissions (permissionAndRoleName) {
    return axios.post('/droits/addOrRemovePermissions', permissionAndRoleName, { headers: this.getHeaders(), withCredentials: true })
  }
}
